module.exports = __webpack_public_path__ + "static/media/img115_R.09aa4715.jpg";